import React, { Component, PureComponent } from "react";
import SelectField from "components/form/select-field";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import Dialog from "material-ui/Dialog";
import { Set, Map, List } from "immutable";
import { Form } from "formsy-react";
import ContentAdd from "material-ui/svg-icons/content/add";
import Trash from "components/icons/trash";
import Button from "components/form/button";
import { format } from "lib/globalize-util";
import SchemaModel from "models/schema";

const styles = {
    dialogRoot: { zIndex: 2500 },
    fieldContainer: { display: "flex", alignItems: "center" },
    select: { flexGrow: 99 },
    iconButton: { marginTop: "20px" },
    dialog: { maxWidth: "450px" },
    dialogButton: { margin: "0 5px 0 5px" },
};

class SummaryFieldsSelector extends PureComponent {
    // props: {
    //     fieldKeyToName: Map<string, string>,
    //     selectedKeys: List<string>,
    //     setFields: (fields: List<string>) => void,
    // };

    renderSelector(field, index) {
        const { fieldKeyToName, selectedKeys, setFields } = this.props;

        const notSelectedOptions = Set(fieldKeyToName.keys()).subtract(selectedKeys);

        const nextToAdd = notSelectedOptions.first();
        const menuOptions = notSelectedOptions.add(field);

        const actionButton =
            index === selectedKeys.size - 1 && nextToAdd ? (
                <IconButton key="add" style={styles.iconButton} onClick={() => setFields(selectedKeys.push(nextToAdd))}>
                    <ContentAdd />
                </IconButton>
            ) : (
                <IconButton
                    key="remove"
                    style={styles.iconButton}
                    onClick={() => setFields(selectedKeys.remove(index))}
                >
                    <Trash color="red" />
                </IconButton>
            );

        const fieldOptions = fieldKeyToName
            .filter((name, key) => menuOptions.has(key))
            .map((name, key) => <MenuItem key={key} value={key} primaryText={name} />)
            .toArray();

        return (
            <div style={styles.fieldContainer} key={index}>
                <SelectField
                    style={styles.select}
                    name="field"
                    label={format("Field")}
                    large={true}
                    value={field}
                    onChange={(event, menuIdx, value) => setFields(selectedKeys.set(index, value))}
                >
                    {fieldOptions}
                </SelectField>
                {actionButton}
            </div>
        );
    }

    render() {
        return <Form>{this.props.selectedKeys.map(this.renderSelector, this)}</Form>;
    }
}

export default class SummaryFieldsDialog extends Component {
    // props: {
    //     id: string,
    //     onRequestClose: () => void,
    //     scope: any,
    //     schemas: any,
    //     schemaIds: any,
    // };

    // state: {
    //     orderFields: Map<string, string>,
    //     selectedKeys: List<string>,
    // };

    // updateSelectedFields: Function;

    constructor(props) {
        super(props);
        this.state = this.getSchemaFields();
        this.updateSelectedFields = this.updateSelectedFields.bind(this);
    }

    updateSelectedFields(selectedKeys) {
        this.setState({ selectedKeys });
    }

    getSchemaFields() {
        const { schemaIds, schemas, scope, me } = this.props;

        if (!scope.brand) {
            return {
                orderFields: Map(),
                selectedKeys: List(),
            };
        }

        if (!schemas) {
            return {
                orderFields: Map(),
                selectedKeys: List(),
            };
        }
        const orderSchemaId = schemaIds.find((schemaId) => {
            return schemas[schemaId].type === "order";
        });
        const orderRecord = schemas[orderSchemaId]?.toJS();
        const schema = new SchemaModel(orderRecord);

        if (!schema) {
            return {
                orderFields: Map(),
                selectedKeys: List(),
            };
        }

        const displayProp = me.account_type === "buyer" ? "display_to_buyers" : "display";
        const orderFields = Map(
            schema.fields
                .filter((field) => field.key.startsWith("line_items.") && field[displayProp])
                .map((field) => [field.key, field.name])
        );
        const orderFieldKeys = orderFields.keySeq().toSet();
        const options = List(String(scope.brand.hasPreference("order_summary_defaults") || "").split(","))
            .map((s) => s.trim())
            .filter((s) => s)
            .map((s) => `line_items.${s.trim()}`)
            .filter((key) => orderFieldKeys.has(key));

        const selectedKeys = options.isEmpty() ? orderFieldKeys.take(1).toList() : options;

        return { orderFields, selectedKeys };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.id !== nextProps.id) {
            this.setState(this.getSchemaFields());
        }
    }

    render() {
        const { scope } = this.props;
        const actions = scope.brand && (
            <div className="button-container">
                <Button
                    type="close"
                    style={styles.dialogButton}
                    label={format("Close")}
                    onClick={this.props.onRequestClose}
                />
                <Button
                    type="submit"
                    label={format("View Report")}
                    style={styles.dialogButton}
                    primary={true}
                    disabled={this.state.selectedKeys.isEmpty()}
                    target="_blank"
                    href={`/brand/${scope.brand._id}/order/${this.props.id}/summary?fields=${this.state.selectedKeys
                        .map((str) => str.slice(11))
                        .join("&fields=")}`}
                />
            </div>
        );

        return (
            <Dialog
                title={format("Select Summary Field(s)")}
                actions={actions}
                open={Boolean(this.props.id)}
                onRequestClose={this.props.onRequestClose}
                contentStyle={styles.dialog}
                autoScrollBodyContent={true}
                style={styles.dialogRoot}
            >
                <SummaryFieldsSelector
                    setFields={this.updateSelectedFields}
                    fieldKeyToName={this.state.orderFields}
                    selectedKeys={this.state.selectedKeys}
                />
            </Dialog>
        );
    }
}
